import React from "react"
import PropTypes from "prop-types"
import { TimelineMax } from "gsap"
import { fadeSpeed } from "../constants"
import TransitionLink from "gatsby-plugin-transition-link"

const TransitionFade = ({
  link,
  children,
  className,
  arialabel,
  tabIndex,
  role,
  ariaExpanded,
}) => {
  if (link?.match(/^(http|https):/) !== null) {
    return <a href={link}>{children}</a>
  }
  return (
    <TransitionLink
      aria-label={arialabel}
      exit={{
        trigger: ({ node }) => {
          const tl = new TimelineMax()
          tl.to(node, fadeSpeed, { autoAlpha: 0 })
        },
        length: 0.25,
      }}
      entry={{
        trigger: ({ node }) => {
          const tl = new TimelineMax()
          tl.to(node, fadeSpeed, { autoAlpha: 1 })
        },
        delay: fadeSpeed,
      }}
      to={link}
      className={className}
      tabIndex={tabIndex}
      role={role}
      aria-expanded={ariaExpanded}
    >
      {children}
    </TransitionLink>
  )
}

TransitionFade.propTypes = {
  link: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  arialabel: PropTypes.string,
  tabIndex: PropTypes.string,
  role: PropTypes.string,
  ariaExpanded: PropTypes.bool,
}

export default TransitionFade
